import React from 'react';
import { Navigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AdminRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-dark-bg">
        <div className="text-center">
          <div className="relative mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-red-400/20 to-orange-500/20 border border-red-500/20 flex items-center justify-center mx-auto animate-pulse-soft">
              <Shield size={28} className="text-red-400" />
            </div>
            <div className="absolute inset-0 w-16 h-16 rounded-2xl mx-auto border-2 border-red-500/30 border-t-red-500 animate-spin" style={{ animationDuration: '1.5s' }} />
          </div>
          <p className="text-gray-400 text-sm font-medium">Verifying admin access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
